import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "@mui/material/Toolbar";
import { Button } from "@mui/material";
import { Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Iframecomponent from "./Iframecomponent";
import axios from "axios";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
} from "@mui/material";

import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import Widget from "./Widget";
import TradingViewWidget from "./TradingViewWidget";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const sxStyles = {
  boldHeader: {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
};

const Referralpage = ({ source }) => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [selectedLeadName, setSelectedLeadName] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedInteractions, setSelectedInteractions] = useState([]);
  const [locationTypes, setlocationTypes] = useState([]);
  const [engagementTypes, setEngagementTypes] = useState([]);
  const [statustypes, setStatustypes] = useState([]);

  const handleLeadNameClick = (leadName, interactions) => {
    console.log("leadname", leadName);
    console.log("leadname2", interactions);
    setSelectedLeadName(leadName);
    setSelectedInteractions(interactions);
    setModalOpen(true);
  };

  const formatDateStringhours = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return `${date.toLocaleDateString("en-GB")} ${date.toLocaleTimeString(
        "en-GB",
        { hour: "2-digit", minute: "2-digit" }
      )}`;
    } else {
      return "N/A";
    }
  };
  const formatDateString = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB");
    } else {
      return "N/A";
    }
  };
  const cancelHandler = () => {
    // handleCloseChangeStatusModal();
    // reset();
    setModalOpen(false);
  };
  const getLocationtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/location_type`;
      const response = await axios.get(url, {
        // Include any data that needs to be sent in the request body here
      });
      // console.log("locationdata", response);
      setlocationTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getEngagementtypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/engagement_type`;
      const response = await axios.get(url, {});
      // console.log("engagementdata", response);
      setEngagementTypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  const getstatustypeData = async () => {
    try {
      const url = `${apiUrl}/CCE/api/v1/referalEngine/getMasterDetails/status`;
      const response = await axios.get(url, {});
      // console.log("waelthndata", response);
      setStatustypes(response.data.response);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getEngagementtypeData();
    getLocationtypeData();
    getstatustypeData();
    // getLeadstatusData();
    // getAnnualincomeData();
  }, []);

  const columns = [
    // { field: "id", headerName: "ID", width: 60, headerClassName: "boldHeader", },

    // {
    //   field: "fullName",
    //   headerName: "Referral Name",
    //   description: "This column has a value getter and is not sortable.",
    //   sortable: false,
    //   width: 140,
    //   headerClassName: "boldHeader",
    //   valueGetter: (params) =>
    //     `${params.row.firstname || ""} ${params.row.lastname || ""}`,
    // },
    {
      field: "fullName",
      headerName: "Referral Name",
      headerAlign: "center",
      cellClassName: "centerAlign",

      renderCell: (params) => (
        <div
          onClick={() =>
            handleLeadNameClick(
              `${params.row.firstname} ${params.row.lastname}`,
              params.row.interactionDetails
            )
          }
          style={{
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {params.row.firstname} {params.row.lastname}
        </div>
      ),
      width: 160,
      headerClassName: "boldHeader",
    },
    {
      field: "email",
      headerName: "Email Address",
      width: 160,
      headerClassName: "boldHeader",
      valueGetter: (params) => params.value || "-",
      editable: true,
      headerAlign: "center",
      cellClassName: "centerAlign",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      width: 130,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      editable: true,
      renderCell: (params) => (
        <span>{params.value && formatIndianPhoneNumber(params.value)}</span>
      ),
    },
    {
      field: "created_date",
      headerName: "Referred Date",
      width: 150,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      valueGetter: (params) =>
        moment(params.row.created_date).format("DD/MM/YYYY"),
      editable: true,
    },
    {
      field: "points",
      headerName: "Points Earned",
      width: 120,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      editable: true,
      renderCell: (params) => {
        const points = params.value;

        return points !== null ? points : "N/A";
      },
    },
    {
      field: "payouts",
      headerName: "Points Received",
      width: 130,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      editable: true,
      renderCell: (params) => {
        const points = params.value;

        return points !== "0.00" ? points : "N/A";
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      editable: true,
      renderCell: (params) => {
        const status = params.value;
        let displayStatus;
        if (status === "referral") {
          displayStatus = "Pending";
        } else if (status === "lead") {
          displayStatus = "In Progress";
        } else if (status === "client") {
          displayStatus = "Client";
        } else {
          displayStatus = status;
        }
        return <div>{displayStatus}</div>;
      },
    },
    {
      field: "managerName",
      headerName: "Point Of Contact",
      width: 160,
      headerClassName: "boldHeader",
      headerAlign: "center",
      cellClassName: "centerAlign",
      editable: true,
    },
  ];

  const interactionColumns = [
    {
      field: "meeting_at",
      headerName: "Meeting Date",
      width: 150,
      headerClassName: "boldHeader",

      renderCell: (params) => (
        <div>
          {/* <div
            onClick={() => handleOpenModal(params.row)}
            style={{ color:"blue", textDecoration:"underline", cursor: 'pointer' }}
          > */}
          {formatDateString(params.value)}
          {/* </div> */}
        </div>
      ),
    },
    // {

    {
      field: "location_type_engagement_type",
      headerName: "Location",
      width: 300,
      headerClassName: "boldHeader",
      renderCell: (params) => {
        const locationType =
          locationTypes.find((item) => item.id === params.row.location_type)
            ?.masterValueDesc || "";
        const engagementType =
          engagementTypes.find((item) => item.id === params.row.engagement_type)
            ?.masterValueDesc || "";

        return (
          <div>
            {engagementType}
            {locationType && `, ${locationType}`}
          </div>
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      width: 150,
      headerClassName: "boldHeader",
      renderCell: (params) => (
        <div>
          {
            statustypes.find((item) => item.id === params.value)
              ?.masterValueDesc
          }
        </div>
      ),
    },
  ];

  const formatIndianPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) {
      return ""; // or handle null/undefined case as needed
    }

    const phoneNumberString = phoneNumber?.toString();
    if (!phoneNumberString) {
      return ""; // handle if phoneNumber.toString() returns null or undefined
    }

    const formattedNumber = `${phoneNumberString.substring(
      0,
      5
    )} ${phoneNumberString.substring(5)}`;
    return formattedNumber;
  };

  columns.forEach((item) => {
    if (item.field === "status" && item.value !== undefined) {
      item.value = item.value.charAt(0).toUpperCase() + item.value.slice(1);
    }
  });
  console.log("columns", columns);
  const handlefunc = () => {
    navigate("/addreferral");
  };

  useEffect(() => {
    const getdata = async () => {
      setLoading(true);
      const headers = {
        "x-access-token": token,
      };
      try {
        let resva;

        if (source === "clients") {
          // Call a different API when the source is "clients"
          resva = await axios.get(
            `${apiUrl}/CCE/api/v1/referalEngine/getReferral/client`,
            {
              headers,
            }
          );
        } else {
          // Default API call
          resva = await axios.get(
            `${apiUrl}/CCE/api/v1/referalEngine/getReferral/all`,
            {
              headers,
            }
          );
        }

        const response = resva.data.response;
        let filteredData = response;

        // Apply search query filter
        const filteredReferrals = response.filter((referral) => {
          // Handle null or undefined values
          const firstname = referral.firstname || "";
          const lastname = referral.lastname || "";
          const email = referral.email || "";
          const fullName = `${firstname} ${lastname}`.toLowerCase();
          const query = searchQuery.toLowerCase();
          return (
            query === "" ||
            fullName.includes(query) ||
            email.toLowerCase().includes(query)
          );
        });

        setdata(filteredReferrals);
      } catch (error) {
        console.error("Error:", error.message);
      } finally {
        setLoading(false);
      }
    };

    getdata();
  }, [source, token, searchQuery]);
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
  };
  //-----------------------------------------------------------------------------

  console.log("Dataaaa", data);

  return (
    <>
      {/* <Box>
      <Widget/>
    </Box> */}
      {/* <Box sx={{width:"300px",border:"1px solid red",height:"600px"}}>
      <TradingViewWidget/>
    </Box> */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          marginTop: "-20px",
          height: "600px",
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            height: 540,
            width: "70%",
            margin: "-70px 0px 0px 0px",
            padding: "10px",
          }}
        >
          <Toolbar />
          <div style={{ height: "7%", textAlign: "left" }}>
            <Paper sx={styles.dashboard_paper}>
              <h3>Referrals</h3>
            </Paper>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "15px 0px 10px 0px",
            }}
          >
            <Box
              sx={{
                textAlign: "left",
                position: "relative",
                margin: "0px 0px",
              }}
            >
              <input
                style={{
                  width: "300px",
                  height: "35px",
                  borderRadius: "8px",
                  paddingLeft: "35px",
                }}
                type="text"
                placeholder="Search by Referral Name or Email..."
                value={searchQuery}
                onChange={handleSearchInputChange}
              />
              <SearchIcon
                sx={{
                  position: "absolute",
                  left: "8px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "grey",
                }}
              />
            </Box>
            <Button onClick={handlefunc} sx={styles.btn} variant="contained">
              Add New Referral
            </Button>
          </div>
          <div className="relative" style={{ height: "540px" }}>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <DataGrid
                rows={data}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                // checkboxSelection
                disableRowSelectionOnClick
                // sx={sxStyles.boldHeader}
                sx={{
                  ...sxStyles.boldHeader,
                  "& .MuiDataGrid-columnHeaders": {
                    textAlign: "center",
                    fontWeight: "bold",
                  },
                  "& .centerAlign": {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  },
                }}
              />
            )}
          </div>
          <Modal
            open={modalOpen}
            // onClose={handleCloseModalnew}
            aria-labelledby="interaction-details-modal-title"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                right: "50%",
                transform: "translate(-50%, -50%)",
                width: 700,
                // height: 600,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: "2px",
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#d9d9d9 #fff", // For Firefox
                "&::-webkit-scrollbar": {
                  width: "2px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#d9d9d9",
                },
              }}
            >
              <Box
                onClick={cancelHandler}
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  cursor: "pointer",
                  color: "#666666",
                  zIndex: 1,
                }}
              >
                <CloseIcon sx={{ fontSize: 30 }} />
              </Box>
              <Typography
                sx={{ marginBottom: "0" }}
                id="interaction-details-modal-title"
                variant="h6"
                component="h2"
              >
                <b>Interaction Details for {selectedLeadName}</b>
              </Typography>
              {selectedInteractions?.length > 0 ? (
                <>
                  <DataGrid
                    rows={selectedInteractions}
                    columns={interactionColumns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    sx={sxStyles.boldHeader}
                  />
                </>
              ) : (
                <Typography sx={{ marginTop: "12px" }}>
                  No interaction details available.
                </Typography>
              )}
            </Box>
          </Modal>
        </Box>
        <Box sx={{ height: 540, width: "30%" }}>
          <Box>
            <TradingViewWidget />
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default Referralpage;

const styles = {
  btn: {
    width: "200px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "400px",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
  },
};
